import React, { useContext, useEffect, useState } from 'react';
import { DatePicker } from 'antd';
import { ReactComponent as Calender } from '../../assets/icons/calendar.svg';
import { ReactComponent as CalenderBlack } from '../../assets/icons/calender-black.svg';
import { ReactComponent as Cancel } from '../../assets/icons/cancel.svg';
import { ReactComponent as CancelBlack } from '../../assets/icons/cancel-black.svg';
import { useTheme } from '../../context/ThemeContext';
import './CustomRangePicker.css';
import {
  DARK,
  ORGANISATION_KEYS,
  RESTRICT_DATA_DATE,
} from '../../utilities/constants';
import Icon, {
  LeftOutlined,
  RightOutlined,
  DoubleLeftOutlined,
  DoubleRightOutlined,
} from '@ant-design/icons';
import dayjs from 'dayjs';
import { UserRolesAndPermissionsContext } from '../../context/UserRolesAndPermissionsContext';
import PropTypes from 'prop-types';

const { RangePicker } = DatePicker;

const CustomRangePicker = ({
  setDateRange,
  maxDateCount = 0,
  minDateCount = 0,
  disabled = false,
  showValue = true,
  value = ['', ''],
  allowClear = true,
}) => {
  const { theme } = useTheme();
  const isDark = theme === DARK;
  const iconStyle = { color: isDark ? '#FFFFFF' : '#000000' };
  const { userDetails } = useContext(UserRolesAndPermissionsContext);
  const [restrictStartDate, setRestrictedDate] = useState(null);

  useEffect(() => {
    if (userDetails?.org === ORGANISATION_KEYS.JPMC) {
      setRestrictedDate(RESTRICT_DATA_DATE.JPMC);
    }
  }, [userDetails?.org]);

  const handleCalenderChange = (dates, dateStrings) => {
    if (dateStrings[0] === '' && dateStrings[1] === '' && restrictStartDate) {
      setDateRange([
        restrictStartDate,
        dayjs().subtract(maxDateCount, 'day').format('DD-MM-YYYY'),
      ]);
    } else {
      setDateRange(dateStrings);
    }
  };

  return (
    <RangePicker
      className="custom-range-picker"
      variant="borderless"
      {...(allowClear
        ? {
            allowClear: {
              clearIcon: (
                <Icon component={theme === DARK ? Cancel : CancelBlack} />
              ),
            },
          }
        : { allowClear: false })}
      popupClassName="dateRangePicker"
      onCalendarChange={handleCalenderChange}
      format="DD-MM-YYYY"
      maxDate={dayjs(
        dayjs().subtract(maxDateCount, 'day').format('DD-MM-YYYY'),
        'DD-MM-YYYY'
      )}
      {...(Number(minDateCount) > 0 && {
        minDate: dayjs().subtract(Number(minDateCount), 'day'),
      })}
      {...(restrictStartDate && {
        minDate: dayjs(restrictStartDate, 'DD-MM-YYYY'),
      })}
      suffixIcon={
        <Icon component={theme === DARK ? Calender : CalenderBlack} />
      }
      prevIcon={<LeftOutlined style={iconStyle} />}
      nextIcon={<RightOutlined style={iconStyle} />}
      superPrevIcon={<DoubleLeftOutlined style={iconStyle} />}
      superNextIcon={<DoubleRightOutlined style={iconStyle} />}
      disabled={disabled}
      value={
        Array.isArray(value) && value[0] && value[1] && showValue
          ? value
          : undefined
      }
    />
  );
};

CustomRangePicker.propTypes = {
  setDateRange: PropTypes.func.isRequired,
  maxDateCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  minDateCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  disabled: PropTypes.bool,
  showValue: PropTypes.bool,
  value: PropTypes.arrayOf(PropTypes.string),
};

export default CustomRangePicker;
